import { useEffect, useState } from "react";
import { readTodo, createTodo, updateTodo } from "./funtions";
import Preloader from "./components/Preloader";
import { deleteTodo } from "./api";
import "./style.css";
function App() {
  const [todo, setTodo] = useState({ title: "", content: "" });
  const [todos, setTodos] = useState(null);
  const [currentId, setCurrentId] = useState(0);
  useEffect(() => {
    let currentTodo =
      currentId != 0
        ? todos.find((todo) => todo._id === currentId)
        : { title: "", content: "" };
    setTodo(currentTodo);
  }, [currentId]);

  useEffect(() => {
    const fetchData = async () => {
      const result = await readTodo();
      setTodos(result);
    };
    fetchData();
  }, [currentId]);
  const clear = () => {
    setCurrentId(0);
    setTodo({ title: "", content: "" });
  };
  useEffect(() => {
    const clearField = (e) => {
      if (e.keyCode === 27) {
        clear();
      }
    };
    window.addEventListener("keydown", clearField);
    return () => window.removeEventListener("keydown", clearField);
  }, []);
  const removeTodo = async (id) => {
    await deleteTodo(id);
    const result = await readTodo();
    setTodos(result);
  };
  const onSubmitHandler = async (e) => {
    e.preventDefault();
    if (currentId === 0) {
      const result = await createTodo(todo);
      setTodos([...todos, result]);
      clear();
    } else {
      await updateTodo(currentId, todo);
      clear();
    }
  };
  return (
    <div
      className="container"
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background: "white",
      }}
    >
      <div className="row">
        <h1
          style={{
            textAlign: "center",
            fontFamily: "Brush Script MT , cursive",
          }}
        >
          My Todos
        </h1>
        <form className="col s12" onSubmit={onSubmitHandler}>
          <div className="row">
            <div className="input-field col s6">
              <i className="material-icons prefix">account_circle</i>
              <input
                placeholder="Enter Title"
                id="title"
                type="text"
                className="validate"
                value={todo.title}
                onChange={(e) => setTodo({ ...todo, title: e.target.value })}
              />
            </div>
            <div className="input-field col s6">
              <i className="material-icons prefix">description</i>
              <input
                placeholder="Enter Description"
                id="content"
                type="text"
                className="validate"
                value={todo.content}
                onChange={(e) => setTodo({ ...todo, content: e.target.value })}
              />
            </div>
          </div>
          <div className="row" style={{ textAlign: "center" }}>
            <button className="wave-effect waves-light btn">Submit</button>
          </div>
        </form>
        {!todos ? (
          <Preloader />
        ) : todos.length > 0 ? (
          <ul className="collection container">
            {todos.map((todo) => (
              <div>
                <li
                  key={todo._id}
                  onClick={() => setCurrentId(todo._id)}
                  className="collection-item"
                >
                  <div>
                    <h5>{todo.title}</h5>
                    <p>
                      {todo.content}
                      <a
                        href="#!"
                        onClick={() => removeTodo(todo._id)}
                        className="secondary-content"
                      >
                        <i className="material-icons">delete</i>
                      </a>
                    </p>
                  </div>
                </li>
              </div>
            ))}
          </ul>
        ) : (
          <div>Nothing To Show</div>
        )}
      </div>
    </div>
  );
}

export default App;
